import { render } from "./circular-progress.vue?vue&type=template&id=40f88361&scoped=true"
import script from "./circular-progress.vue?vue&type=script&lang=js"
export * from "./circular-progress.vue?vue&type=script&lang=js"

import "./circular-progress.vue?vue&type=style&index=0&id=40f88361&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f88361"]])

export default __exports__